import script from "./ClassicUserLoginStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassicUserLoginStep.vue?vue&type=script&setup=true&lang=js"

import "./ClassicUserLoginStep.vue?vue&type=style&index=0&id=5ed6cf05&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/actions-runner/_work/keepyoursight/keepyoursight/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed6cf05"]])

export default __exports__